/**
* 路由
*/
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '$stores'

// import各业务路由模块
import routesCommon from '$routes/modules/common'
import routesOrder from '$routes/modules/order'

import getBackClose from '@common/client/src/getBackClose'
import clientTitle from '@common/client/src/title'
import { login } from '@finance/login'
import toast from '@common/toast'

Vue.use(VueRouter)
const router = new VueRouter({
  routes: routesCommon.concat(routesOrder),
})


// 声明一个全局变量，控制loading延时加载
let loadingTimeoutCtrl = null

/**
 * 路由进入前，统一事件处理
 * 1、开启loading
 * 2、登录控制
 */
router.beforeEach((to, from, next) => {
  clearTimeout(loadingTimeoutCtrl)
  loadingTimeoutCtrl = setTimeout(() => {
    store.commit('showLoading')
  }, 350)
  if (to.meta.needLogin) {
    const url = encodeURIComponent(window.location.href)
    login({
      type: to.meta.loginType || 0,
      accountType: to.meta.accountType || 1,
      forwardUrl: url,
      success: () => {
        next()
      },
      error: (message) => {
        store.commit('hideLoading')
        const msg = message && message.msg ? message.msg : '网络发生错误了，请稍后重试'
        toast(msg)
      },
      cancel: () => {
        store.commit('hideLoading')
      },
    })
  } else {
    next()
  }
})

/**
 * 路由进入后，统一事件处理
 * 1、关闭loading
 * 2、页面title
 * 3、随手记【返回】按钮控制
 * 4、container class处理
 */
router.afterEach((to) => {
  clearTimeout(loadingTimeoutCtrl)
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 0)
  store.commit('hideLoading')
  // 全局控制随手记返回按钮动作
  getBackClose(to.query.getBackClose)
  if (to.meta.title) {
    // 更新页面title
    clientTitle.set(to.meta.title)
  }

  // 更换container class
  const { containerClass = '' } = to.meta
  store.commit('setContainerClass', containerClass)
})

export default router



// WEBPACK FOOTER //
// ./src/routes/index.js